<template>
  <div class="d-flex flex-row flex-xl-column justify-content-between justify-content-xl-start align-items-xl-start align-items-center">
    <label class="text-secondary mb-0" :class="{ 'font-weight-bold text-danger' : localShowUnselected && value === null || showUnselected && value === null }">{{label}}
        <br v-if="$runtimeEnvironment.isMobile && visible && hasAnyFlexibleItems"/>
        <span 
          v-if="$runtimeEnvironment.isMobile && visible && hasAnyFlexibleItems"
          class="flexible-description text-light"></span>
        <small v-if="$runtimeEnvironment.isMobile && visible && hasAnyFlexibleItems"><small> = flexibel</small></small>
    </label>
    <div class="d-flex flex-wrap" v-if="visible" :class="{'pb-1 border-bottom border-danger': localShowUnselected && value === null || showUnselected && value === null}" role="list" tabindex=0>
      <div 
        v-for="item in items"
        :key="item.id"
        :style="`height: 35px; width: 35px; margin: 8px; background: linear-gradient(135deg, ${getCssColor(item.colorTop)} 50%, ${getCssColor(item.colorBottom)} 50%)`"
        class="rounded-circle multi-color text-center text-white selected-cable-color clickable"
        :class="{
          'opacity-25 cursor-not-allowed' : disabledItems && disabledItems.indexOf(item) >= 0,
          'inner-shadow' : ['YA01-0014', 'YA01-0009', 'YA01-0016', 'YA01-0019'].includes(item.id),
          'flexible' : item.flexibility !== '',
          'cursor-not-allowed disabled': disabledItems.map(disabledItem => disabledItem.id).includes(item.id),
          'selected': localValue === item.id
        }"
        :title="`${ item.colorTop === item.colorBottom ? $t('colorNames.' + item.colorTop) : $t('colorNames.' + item.colorTop) + '/' + $t('colorNames.' + item.colorBottom)}${ item.flexibility !== '' ? ' - ' + $t('flexible') : ''}`" 
        @click.prevent="disabledItems.map(disabledItem => disabledItem.id).includes(item.id) ? '' : setSelection(item)"
        @keyup.space="disabledItems.map(disabledItem => disabledItem.id).includes(item.id) ? '' : setSelection(item)"
        @keyup.enter="disabledItems.map(disabledItem => disabledItem.id).includes(item.id) ? '' : setSelection(item)"
        role="listitem"
        tabindex=0
      >
        <span 
          :class="[(['YA01-0014', 'YA01-0009', 'YA01-0016', 'YA01-0019'].includes(item.id) ? 'text-dark': '')]" 
          v-if="value === item.id" class="align-middle" 
          >
            <i v-if="item.flexibility === ''" class="fas fa-check position-relative" style="top: 6px;"></i>
            <i v-if="item.flexibility !== ''" class="fas fa-check position-relative" style="top: 28px; left: -10px;"></i>
          </span>
      </div>
    </div>
    <div class="info-icon mx-1" v-if="$runtimeEnvironment.isMobile && !visible">
      <i class="fas fa-info-circle text-danger"></i>
    </div>
    <div 
      class="font-italic my-2 mx-auto text-left text-md-center w-100" 
      v-if="!visible"
      :class="[
       $runtimeEnvironment.isMobile ? 'text-warning' : 'text-muted'
      ]">
      {{ $t('please-select-plug') }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MultiColorSelectComponent',
  props: {
    items: Array,
    label: String,
    disabledItems: {
      type: Array,
      default: () => []
    },
    value: String,
    filterKey: {
      type: String,
      required: true
    },
    filterPropertyName: {
      type: String,
      required: true
    },
    visible: Boolean,
    showUnselected: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "value",
    event: "update"
  },
  data () {
    return {
      localValue: this.value,
      localShowUnselected: this.showUnselected
    }
  },
  methods: {
    setSelection: function (item) {
      if (this.localValue === item.id) {
        this.localValue = item.id
        this.$emit("update", null)
        try {
          this.$store.dispatch('removeAutoAppliedFiltersAndLastFilterAndFilter', { filterKey: this.filterKey, propertyName: this.filterPropertyName })
        } catch (err) {
          this.$rollbar.error('Can not set filter to store', err)
        }
        return 
      }
      
      this.localValue = item.id
      this.$emit("update", item.id)
      try {
        this.$store.dispatch('setLastFilterAndFilter', { filterKey: this.filterKey, propertyName: this.filterPropertyName, propertyValue: item.id })
      } catch (err) {
        this.$rollbar.error('Can not set filter to store', err)
      }

      if (this.value) this.localShowUnselected = false
    },
    
  },
  computed: {
    ...mapGetters([
      'getCssColor'
    ]),
    hasAnyFlexibleItems () {
      return this.items.map(item => item.flexibility).includes('flexibel')
    }
  },
  watch: {
    value (newValue) {
      this.localValue = newValue
      if (this.value) this.localShowUnselected = false
    },

    // autoFill
    items: {
      handler (newValue) {
        // console.log(newValue)
        if (newValue.length === 1) {
          this.localValue = newValue[0].id
          this.$emit("update", newValue[0].id)
          try {
            this.$store.dispatch('setLastFilterAndFilter', { filterKey: this.filterKey, propertyName: this.filterPropertyName, propertyValue: newValue[0].id })
          } catch (err) {
            this.$rollbar.error('Can not set filter to store', err)
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.inner-shadow {
  box-shadow: rgba(169, 169, 169, .25) 0px 0px 1px 2px inset;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.pointer-events-none {
  pointer-events: none;
}

.flexible::before {
  content: "\F83E";
  background-color: $saka-orange;
  height: 1.25rem;
  width: 1.25rem;
  position: relative; 
  top: -10px;
  left: 15px;
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  font-size: 0.5rem;
  border-radius: 999px;
  padding: 5px;
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;
}
.flexible-description::before {
  content: "\F83E";
  background-color: $saka-orange;
  height: 1.25rem;
  width: 1.25rem;
  position: relative; 
  top: 0px;
  left: 0px;
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  font-size: 0.5rem;
  border-radius: 999px;
  padding: 5px;
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;
}
.flexible:focus {
  outline: none;
}

.flexible.selected::before {
  left: 22px;
}

.flexible > span {
  position: relative;
  top: -1.5em;
  left: 1px;
}

.multi-color.disabled {
  opacity: .3;
}
.multi-color:first-child {
  margin-left: 0px !important;
}
</style>